export class OpnOfferEvaluationMethodModel {
  id: number;
  assessmentAreaId: number;
  description: string;
  points: number;
}

export class OpnOfferEvaluationMethodSaveModel {
  requestId: number;
  elements:  OpnOfferEvaluationMethodModel[];
}
